@switch (activePanel()) {
  <!-- ------------------------------------------------------------------------ -->
  <!-- -----------NEW TASK CREATION PANELS (only on new task creation)--------- -->
  <!-- ------------------------------------------------------------------------ -->

  <!-- -----------------------NEW BASIC INFO---------------------- -->
  @case (ProjectTaskDialogPanels.NewBasicInfo) {
    <projects-task-new-item-wrapper
      class="new-task__basic-info-container"
      [activePanel]="activePanel()"
      headerText="Task Information"
      [headerMarginBottom]="25"
      [panelIsValid]="form.get('label').value"
      (skip)="onSkipToSubtasks()"
      (cancel)="onCancel()"
      (next)="onChangePanel(ProjectTaskDialogPanels.NewTriggers); skipToSubtasks = false"
    >
      <div class="row">
        <task-icon-picker-button
          [iconName]="form.get('icon').value"
          (buttonClick)="onChangePanel(ProjectTaskDialogPanels.IconPicker)"
          [lightBackground]="true"
        ></task-icon-picker-button>
        <oph-input-inside-label
          label="Task Name"
          [control]="$any(form.get('label'))"
          [invalid]="form.get('label').invalid && form.get('label').touched"
          [defaultFocus]="true"
          [backgroundColor]="'var(--lightest)'"
          [style]="{'border-radius': '10px'}"
        ></oph-input-inside-label>
      </div>
      <projects-task-details
        [form]="form"
        [newTask]="data.newTask"
        [teamsMap$]="teamsMap$"
        [usersMap$]="usersMap$"
        [skillsMap$]="skillsMap$"
        (panelChange)="onChangePanel($event)"
      ></projects-task-details>
    </projects-task-new-item-wrapper>
  }
  <!-- -----------------------NEW TRIGGERS---------------------- -->
  @case (ProjectTaskDialogPanels.NewTriggers) {
    <projects-task-new-item-wrapper
      class="new-task__triggers-container"
      [activePanel]="activePanel()"
      headerText="Does this task have a trigger?"
      [headerMarginBottom]="64"
      [panelIsValid]="isTriggerPanelValid()"
      (back)="onChangePanel(ProjectTaskDialogPanels.NewBasicInfo)"
      (cancel)="onCancel()"
      (next)="
        form.get('triggers')?.value.length > 0
          ? onChangePanel(ProjectTaskDialogPanels.NewSubtasks)
          : onChangePanel(ProjectTaskDialogPanels.NewSchedule)
      "
    >
      <projects-task-triggers
        [form]="form"
        [newTask]="data.newTask"
        [isTriggerPanelValid]="isTriggerPanelValid"
        (newTrackerClick)="onNewTracker($event)"
        (changePanel)="onChangePanel($event.panel, $event.dateTimeControlName)"
      ></projects-task-triggers>
    </projects-task-new-item-wrapper>
  }

  <!-- -----------------------SCHEDULE---------------------- -->
  @case (ProjectTaskDialogPanels.NewSchedule) {
    <projects-task-new-item-wrapper
      [activePanel]="activePanel()"
      headerText="Schedule your task"
      [headerMarginBottom]="30"
      [panelIsValid]="isSchedulePanelValid()"
      (back)="onChangePanel(ProjectTaskDialogPanels.NewTriggers)"
      (cancel)="onCancel()"
      (next)="onChangePanel(ProjectTaskDialogPanels.NewSubtasks)"
    >
      <div class="new-schedule-content-container">
        <projects-task-schedule
          [form]="form"
          [newTask]="data.newTask"
          [isSchedulePanelValid]="isSchedulePanelValid"
          [hasValidTrigger]="isOneTriggerComplete"
          [validationErrors]="validationErrors()"
          (changePanel)="onChangePanel($event.panel, $event.dateTimeControlName)"
          (newTrackerClick)="onNewTracker($any($event))"
        ></projects-task-schedule>
      </div>
    </projects-task-new-item-wrapper>
  }

  <!-- -----------------------NEW SUBTASKS---------------------- -->
  @case (ProjectTaskDialogPanels.NewSubtasks) {
    <projects-task-subtasks
      [form]="form"
      [newTask]="data.newTask"
      [isTemplate]="data.isTemplate"
      [projectId]="data.project._id"
      [skipToSubtasks]="skipToSubtasks"
      [loadingSave]="loadingSave()"
      (changePanel)="onChangePanel($event)"
      (finish)="onSave()"
    ></projects-task-subtasks>
  }

  <!-- -----------------------CANCEL---------------------- -->
  @case (ProjectTaskDialogPanels.NewCancel) {
    <div class="confirmation-container">
      <h1>Are you sure you want to cancel?</h1>
      <oph-icon name="task-dialog-cancel" [size]="90"></oph-icon>
      <button class="confirmation-button" (click)="onCloseDialog()">Yes, cancel</button>
      <button class="confirmation-button" (click)="onChangePanel(storedPanel)">No, back to editing</button>
    </div>
  }

  <!-- -----------------------NEW SUCCESS---------------------- -->
  @case (ProjectTaskDialogPanels.NewSuccess) {
    <div class="confirmation-container">
      <h1>Success! Task created.</h1>
      <oph-icon name="task-dialog-success" [size]="90"></oph-icon>
      <button class="confirmation-button" (click)="onCreateAnotherTask()">Create another task</button>
      <button class="confirmation-button" (click)="onCloseDialog()">All done</button>
    </div>
  }

  <!-- ------------------------------------------------------------------------ -->
  <!-- ----------------------------SHARED PANELS---------------------------- -->
  <!-- ------------------------------------------------------------------------ -->
  @case (ProjectTaskDialogPanels.IconPicker) {
    <task-icon-picker (iconChange)="onIconChange($event)"></task-icon-picker>
  }
  @case (ProjectTaskDialogPanels.Assignments) {
    <div class="fade-slide-up">
      <task-dialog-requirements
        [form]="form"
        [project]="project()"
        (back)="onChangePanel(data.newTask ? ProjectTaskDialogPanels.NewBasicInfo : ProjectTaskDialogPanels.Default)"
        (addPeople)="onAddPeople()"
      ></task-dialog-requirements>
    </div>
  }
  @case (ProjectTaskDialogPanels.NewTracker) {
    <new-tracker-in-dialog
      [projectId]="data.project._id"
      [hideMetricCheckboxes]="true"
      (closeNewTrackerInDialog)="onCloseNewTrackerInDialog($event?.trackerId)"
    ></new-tracker-in-dialog>
  }
  @case (ProjectTaskDialogPanels.DateTimePicker) {
    <projects-task-date-time-picker
      [form]="form"
      [dateTimeControl]="dateTimeControl()"
      [disableTimeSelector]="dateTimeControlName() === 'expirationDate'"
      [minDate]="minDate()"
      (changePanel)="onDateTimePickerChange()"
    ></projects-task-date-time-picker>
  }
  @case (ProjectTaskDialogPanels.PeopleTeamsSelection) {
    <div class="fade-slide-up">
      <projects-users-teams-selection
        [data]="addPeopleData()"
        (backButtonClick)="onChangePanel(ProjectTaskDialogPanels.Assignments)"
        (modifyUserTeamList)="onModifyUserTeamList($event)"
      ></projects-users-teams-selection>
    </div>
  }

  <!-- ------------------------------------------------------------------------ -->
  <!-- ----------------------------EDIT TASK PANELS---------------------------- -->
  <!-- ------------------------------------------------------------------------ -->

  <!-- -----------------------DEFAULT---------------------- -->
  @case (ProjectTaskDialogPanels.Default) {
    <div class="default-container">
      <div class="row">
        <task-icon-picker-button
          [iconName]="form.get('icon').value"
          (buttonClick)="onChangePanel(ProjectTaskDialogPanels.IconPicker)"
        ></task-icon-picker-button>
        <oph-input-inside-label
          label="Task Name"
          [control]="$any(form.get('label'))"
          [invalid]="form.get('label').invalid && form.get('label').touched"
          [defaultFocus]="true"
          [backgroundColor]="'var(--lightest)'"
          [style]="{'border-radius': '10px'}"
        ></oph-input-inside-label>
      </div>

      <div class="default-body mt-16">
        <projects-task-default-tabs
          [selectedTab]="selectedTab()"
          [triggerCount]="triggerCount()"
          [subtaskCount]="subtaskCount()"
          [template]="data.isTemplate"
          (tabChange)="onTabChange($any($event))"
        ></projects-task-default-tabs>
        @if (selectedTab() === ProjectTaskDialogTabs.Details) {
          <projects-task-details
            class="edit-task-details"
            [newTask]="data.newTask"
            [form]="form"
            [teamsMap$]="teamsMap$"
            [usersMap$]="usersMap$"
            [skillsMap$]="skillsMap$"
            [isTemplate]="data.isTemplate"
            (panelChange)="onChangePanel($event)"
          ></projects-task-details>
        }
        @if (selectedTab() === ProjectTaskDialogTabs.Schedule) {
          <projects-task-schedule
            class="edit-task-schedule"
            [form]="form"
            [newTask]="data.newTask"
            [isSchedulePanelValid]="isSchedulePanelValid"
            [validationErrors]="validationErrors()"
            [hasValidTrigger]="isOneTriggerComplete"
            [isTriggerPanelValid]="isTriggerPanelValid()"
            (changePanel)="onChangePanel($event.panel, $event.dateTimeControlName)"
            (newTrackerClick)="onNewTracker($any($event))"
          ></projects-task-schedule>
        }
        @if (selectedTab() === ProjectTaskDialogTabs.Subtasks) {
          <projects-task-subtasks
            [form]="form"
            [newTask]="data.newTask"
            [isTemplate]="data.isTemplate"
            [projectId]="data.project._id"
            [skipToSubtasks]="skipToSubtasks"
            [loadingSave]="loadingSave()"
            (changePanel)="onChangePanel($event)"
            (finish)="onSave()"
          ></projects-task-subtasks>
        }
      </div>

      <projects-task-default-footer
        [loading]="loadingSave()"
        [isTemplate]="data.isTemplate"
        [hideMenu]="(data.isTemplate && !data.taskTemplate) || data.newTask"
        (cancel)="onCancel()"
        (save)="onSave()"
        (delete)="onDelete()"
        (duplicate)="onDuplicate()"
        (createTemplate)="onCreateTemplate()"
      ></projects-task-default-footer>
    </div>
  }

  <!-- -----------------------EDIT SUBTASKS---------------------- -->
  @case (ProjectTaskDialogPanels.SubtaskEdit) {
    <projects-task-subtasks
      [form]="form"
      [newTask]="data.newTask"
      [isTemplate]="data.isTemplate"
      [projectId]="data.project._id"
      [skipToSubtasks]="skipToSubtasks"
      [loadingSave]="loadingSave()"
      [editingTask]="true"
      (changePanel)="onChangePanel($event)"
      (finish)="onSave()"
    ></projects-task-subtasks>
  }

  <!-- -----------------------DELETE---------------------- -->
  @case (ProjectTaskDialogPanels.DeleteTaskConfirmation) {
    <div class="confirmation-container">
      <h1>Are you sure you want to remove this task from the current project?</h1>
      <oph-icon name="task-dialog-cancel" [size]="90"></oph-icon>
      <button class="confirmation-button" (click)="onConfirmRemoveTask()">
        @if (loadingDelete()) {
          <div class="oph-orange-spinner">
            <mat-spinner class="custom-color" diameter="20"></mat-spinner>
          </div>
        } @else {
          Yes, delete
        }
      </button>
      <button class="confirmation-button" (click)="onConfirmationCancel()">No, back to editing</button>
    </div>
  }

  @case (ProjectTaskDialogPanels.DeleteTemplateConfirmation) {
    <div class="confirmation-container">
      <h1>Are you sure you want to delete this task template?</h1>
      <oph-icon name="task-dialog-cancel" [size]="90"></oph-icon>
      <button class="confirmation-button" (click)="onConfirmDeleteTemplate()">
        @if (loadingDelete()) {
          <div class="oph-orange-spinner">
            <mat-spinner class="custom-color" diameter="20"></mat-spinner>
          </div>
        } @else {
          Yes, delete
        }
      </button>
      <button class="confirmation-button" (click)="onConfirmationCancel()">No, back to editing</button>
    </div>
  }
}
